import PropTypes from 'prop-types';

import React, { Component } from 'react';
import { Icon, Label } from '@tcc/crate';
import { getMessage } from 'util/locale';

class Tag extends Component {

  constructor(props) {
    super(props);

    this.state = { editing: false };

    this.textInput = React.createRef();

    this.handleIconClick = this.handleIconClick.bind(this);
    this.handleEditBlur = this.handleEditBlur.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }

  handleIconClick() {
    if (this.props.removeTag) {
      this.props.removeTag(this.props.tag);
    }
  }

  handleClick(e) {
    e.stopPropagation();
  }

  handleEditBlur(e) {
    this.setState({ editing: false });
    this.props.handleTagEdit(this.props.tag, e.target.value);
  }

  handleKeyPress(e) {
    if (e.key === 'Enter') {
      this.handleEditBlur(e);
    }
  }

  render() {
    const { canDelete, isCustom, tag, testId } = this.props;
    let tagTestId = tag.isValid ? testId : testId + '-error';
    let value = tag.value;

    return (
      <div className="tagContainer" data-test-id={tagTestId} onClick={this.handleClick}>
        {value}
        {isCustom
          && <Label className='custom-chemical-tank-mix-inline-badge' status='default'>
            {getMessage('text__use-custom-label-abbrev')}
          </Label>}
        {canDelete && <span className="closeIcon" data-test-id="remove-tag" onClick={this.handleIconClick}>
          <Icon glyph={Icon.set.REMOVE} />
        </span>}
      </div>
    );
  }
}

Tag.defaultProps = {
  canDelete: true,
  testId: ''
};

Tag.propTypes = {
  canDelete: PropTypes.bool,
  handleTagEdit: PropTypes.func,
  isCustom: PropTypes.bool,
  removeTag: PropTypes.func,
  tag: PropTypes.object,
  testId: PropTypes.string
};

export default Tag;
